import Landing from './ui';

export default Landing;